import React from "react"

import PageBase from "components/Common/PageBase"
import FullSpinner from "components/Common/FullSpinner"

import useConfigs from "./useConfigs"
import { BREADCRUMB_LIST } from "./static"
import ConfigsHeader from "./components/ConfigsHeader"
import ProvidersWindowCard from "./components/ProvidersWindowCard"
import SummaryCards from "./components/SummaryCards"
import ClientsToolbar from "./components/ClientsToolbar"
import BulkBar from "./components/BulkBar"
import ClientsTable from "./components/ClientsTable"

import "./configs.css"

const ConfigsContainer = () => {
  const { state, events } = useConfigs()

  return (
    <>
      {state.isLoading && <FullSpinner />}

      <PageBase
        titleMeta="Configuraciones"
        titleBread="Configuraciones"
        itemsBread={BREADCRUMB_LIST}
      >
        {state.modelo && (
          <div className="cfg-page">
            <ConfigsHeader
              dirtyCount={state.dirtyCount}
              hayInvalidos={state.hayInvalidos}
              isSaving={state.isSaving}
              isSaved={state.isSaved}
              onDescartar={events.onDescartar}
              onGuardar={events.onGuardar}
            />

            <ProvidersWindowCard
              prov={state.modelo.prov}
              duracion={state.resumen.provDuracion}
              onChange={events.onChangeProv}
            />

            <SummaryCards resumen={state.resumen} />

            <div className="cfg-card cfg-clients cfg-anim">
              <ClientsToolbar
                search={state.search}
                sort={state.sort}
                onlyChanged={state.onlyChanged}
                listadoLabel={state.listadoLabel}
                onSearch={events.setSearch}
                onSort={events.setSort}
                onToggleOnlyChanged={events.setOnlyChanged}
              />

              {state.selected.length > 0 && (
                <BulkBar
                  selected={state.selected}
                  bulk={state.bulk}
                  onChange={events.onChangeBulk}
                  onAplicar={events.onAplicarBulk}
                  onLimpiar={events.onClearSeleccion}
                />
              )}

              <ClientsTable
                list={state.list}
                todosSeleccionados={state.todosSeleccionados}
                onToggleTodos={events.onToggleTodos}
                onChange={events.onChangeCliente}
                onToggleSeleccion={events.onToggleSeleccion}
              />
            </div>
          </div>
        )}
      </PageBase>
    </>
  )
}

export default ConfigsContainer
